import React, { useEffect, useState, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import './style.css'
import L from 'leaflet';
import 'react-tooltip/dist/react-tooltip.css'
import { useMediaQuery } from 'react-responsive';
import { WiThermometer } from "react-icons/wi";
import { WiHumidity } from "react-icons/wi";
import { FaWind } from "react-icons/fa6";
import { WiBarometer } from "react-icons/wi";
import { FaCalendarAlt } from "react-icons/fa";
import { CgClose } from "react-icons/cg";



const createCustomIcon = (aqi) => {
    const iconHtml = `
      <div class="custom-icon" style="background-color: ${getColorForAQI(aqi)};">
        <span>${aqi}</span>
      </div>
    `;
    return L.divIcon({
        className: "my-custom-icon",
        html: iconHtml,
        iconSize: L.point(40, 40),
    });
};

const getColorForAQI = (aqi) => {
    if (aqi <= 25) return '#009965';
    if (aqi <= 50) return '#76bb53';
    if (aqi <= 75) return '#fcde41';
    if (aqi <= 100) return '#fcbd3e';
    if (aqi <= 125) return '#fb9c3c';
    if (aqi <= 150) return '#e44e38';
    return '#cc0033';
};

const getTextForAQI = (aqi) => {
    if (aqi <= 25) return 'Good';
    if (aqi <= 50) return 'Fair';
    if (aqi <= 75) return 'Moderate';
    if (aqi <= 100) return 'Concerning';
    if (aqi <= 125) return 'Unhealthy for some';
    if (aqi <= 150) return 'Unhealthy for long term';
    return 'Unhealthy';
};

const getDescForAQI = (aqi) => {
    if (aqi <= 25) return 'Good';
    if (aqi <= 50) return 'Fair';
    if (aqi <= 75) return 'Moderate';
    if (aqi <= 100) return 'Concerning';
    if (aqi <= 125) return 'Unhealthy for some';
    if (aqi <= 150) return 'Unhealthy for long term';
    return 'Unhealthy';
};

const Legend = () => {
    const map = useMap();

    useEffect(() => {
        const legend = L.control({ position: 'bottomright' });

        legend.onAdd = function () {
            const div = L.DomUtil.create('div', 'info legend');
            const grades = ['Good', 'Fair', 'Moderate', 'Concerning', 'Unhealthy for some', 'Unhealthy for long term', 'Unhealthy'];
            const colors = ['#009965', '#76bb53', '#fcde41', '#fcbd3e', '#fb9c3c', '#e44e38', '#cc0033'];

            for (let i = 0; i < grades.length; i++) {
                div.innerHTML +=
                    '<i style="background:' + colors[i] + '; width: 18px; height: 18px; float: left; margin-right: 8px;"></i> ' +
                    grades[i] + '<br>';
            }
            return div;
        };

        legend.addTo(map);

        return () => {
            legend.remove();
        };
    }, [map]);

    return null;
};
function calculateAQI(pm25) {
    let aqi;
    if (pm25 <= 12) {
        aqi = linear(50, 0, 12, 0, pm25);
    } else if (pm25 <= 35.4) {
        aqi = linear(100, 51, 35.4, 12.1, pm25);
    } else if (pm25 <= 55.4) {
        aqi = linear(150, 101, 55.4, 35.5, pm25);
    } else if (pm25 <= 150.4) {
        aqi = linear(200, 151, 150.4, 55.5, pm25);
    } else if (pm25 <= 250.4) {
        aqi = linear(300, 201, 250.4, 150.5, pm25);
    } else if (pm25 <= 350.4) {
        aqi = linear(400, 301, 350.4, 250.5, pm25);
    } else if (pm25 <= 500.4) {
        aqi = linear(500, 401, 500.4, 350.5, pm25);
    } else {
        aqi = "Beyond the AQI scale";
    }
    return aqi;
}

function linear(AQIhigh, AQIlow, Conchigh, Conclow, Concentration) {
    const a = ((Concentration - Conclow) / (Conchigh - Conclow)) * (AQIhigh - AQIlow) + AQIlow;
    return Math.round(a);
}

const Purpleairdata = () => {
    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const center = [7.2955, 80.6356]; // Center of the map
    const [sidebarStyle, setSidebarStyle] = useState({});
    const apiKey = 'FE15BB1B-F87E-11EE-B9F7-42010A80000D';
    const mapRef = useRef(null);

    useEffect(() => {
        const fetchSensorData = async () => {
            const apiKey = 'FE15BB1B-F87E-11EE-B9F7-42010A80000D';
            const sensors = [
                { sensorIndex: 12451, lat: 7.2955, lon: 80.6356, name: 'Akurana', province: 'Central Province' },
                { sensorIndex: 29677, lat: 6.7051, lon: 79.9017, name: "Colombo Gregory's Road", province: 'Western Province' }
            ];
            const fields = 'last_modified,pm2.5,temperature,humidity,pressure';
            try {
                const promises = sensors.map(sensor =>
                    fetch(`https://api.purpleair.com/v1/sensors/${sensor.sensorIndex}?fields=${encodeURIComponent(fields)}`, {
                        headers: { 'X-API-Key': apiKey }
                    }).then(response => response.json().then(data => ({
                        ...sensor,
                        ...data.sensor,
                        aqius:calculateAQI( data.sensor['pm2.5']),
                        tp: data.sensor['temperature'],
                        hu: data.sensor['humidity'],
                        pr: data.sensor['pressure'],
                        last_modified :data.data_time_stamp,
                    })))
                );
                const results = await Promise.all(promises);
                setLocations(results);
                setIsLoading(false);
                
            } catch (error) {
                console.error('Failed to fetch data:', error);
                setError(error.message);
                setIsLoading(false);
            }
        };
        fetchSensorData();
    }, []);




    const handleMarkerClick = (location) => {
        setSelectedLocation(location);
    };


    const formatDateTime = (unixTimestamp) => {
        // Convert Unix timestamp (seconds since Epoch) to milliseconds by multiplying by 1000
        const date = new Date(unixTimestamp * 1000);
        
        const optionsDate = { month: 'short', day: 'numeric', year: 'numeric' };
        const optionsTime = { hour: 'numeric', minute: 'numeric', hour12: true };
    
        const formattedDate = date.toLocaleDateString('en-US', optionsDate);
        const formattedTime = date.toLocaleTimeString('en-US', optionsTime);
    
        return `${formattedDate}, ${formattedTime}`;
    };

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!locations.length) {
        return <div>No data available.</div>;
    }


    return (
        <>
            <div className="map-and-sidebar-container">
                <MapContainer className='map-container' center={center} zoom={7} style={{ height: '600px', width: '100%' }} ref={mapRef}>
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    {locations.map((location, index) => (
                        <Marker key={index} position={[location.lat, location.lon]} icon={createCustomIcon(location.aqius)} eventHandlers={{
                            click: () => handleMarkerClick(location),
                        }}>
                        </Marker>
                    ))}
                    <Legend />
                </MapContainer>
                {selectedLocation && (
                    <div className="sidebar" style={sidebarStyle}>
                        <div className='sidebar-header'>
                            <p className='airinfotext'>Air Quality Information</p>
                            <CgClose className='close-icon' onClick={() => setSelectedLocation(null)} />
                        </div>
                        <div className='aqcontainer'>
                            <p className='locationname'>{selectedLocation.name}, Sri Lanka</p>
                            <p className='state'>{selectedLocation.province}</p>
                            <p className='datetime'> <FaCalendarAlt />  {formatDateTime(selectedLocation.last_modified)}</p>
                        
                        <div className='aqicontainer'>
                            <div className='aqivalue' style={{
                                backgroundColor: getColorForAQI(selectedLocation.aqius), textAlign: center,
                            }} >
                                <p className='aqitext'> AQ Index </p>
                                <p className='aqi'>{selectedLocation.aqius} </p>

                                <p className='text'> {getTextForAQI(selectedLocation.aqius)}</p>
                            </div>
                            <div className='temp'>
                                <p className='tempicon'><WiThermometer /> </p>
                                <p className='icon'>{selectedLocation.tp}°C </p>
                            </div>
                        </div>
                        </div>
                        <div className='conditionscon'>
                            <p className='conditions'>Conditions</p>
                            <div className='details'>
                                <div className='name'>
                                    <p className='name1'>Humidity</p>
                                    <p className='name3'>Pressure</p>

                                </div>
                                <div className='variable'>
                                    <div className='icons'>
                                        <p className='hume'><WiHumidity /></p>
                                        <p className='pressure'><WiBarometer /></p>

                                    </div>
                                    <div className='value'>
                                        <p className='value2'>{selectedLocation.hu}%</p>
                                        <p className='value4'>{selectedLocation.pr} mbar</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Purpleairdata;
